import AIGeneratedLabel from "@/components/landing/blog/AIGeneratedLabel";
import { BlogPost } from "@/data/blogPosts";
import BlogTableOfContents from "./BlogTableOfContents";
import BlogShareButtons from "./BlogShareButtons";
import { Link } from "react-router-dom";
import BlogFAQ from "./BlogFAQ";

interface BlogContentProps {
  post: BlogPost;
}

const BlogContent = ({ post }: BlogContentProps) => {
  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Sidebar - Table of Contents */}
            <aside className="lg:w-72 shrink-0">
              <div className="lg:sticky lg:top-24 space-y-6">
                {/* Share Buttons */}
                <BlogShareButtons title={post.title} />

                {/* Table of Contents */}
                <BlogTableOfContents sections={post.content} />
              </div>
            </aside>

            {/* Main Content */}
            <article className="flex-1 min-w-0">
              {/* Cover Image */}
              {!post.hideCoverInArticle && (
              <div className="relative aspect-video bg-secondary/50 rounded-xl overflow-hidden mb-12">
                <img
                  src={post.coverImage}
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
<AIGeneratedLabel slug={post.slug} />
              </div>
              )}

              {/* Content Sections */}
              <div className="prose prose-lg max-w-none">
                {post.intro && (
                  <div
                    className="mb-12 text-lg text-muted-foreground leading-relaxed [&>p]:mb-4 [&>ul]:mb-4 [&>ul]:list-disc [&>ul]:pl-6 [&>ol]:mb-4 [&>ol]:list-decimal [&>ol]:pl-6 [&>li]:mb-2 [&>h4]:text-lg [&>h4]:font-semibold [&>h4]:text-foreground [&>h4]:mt-6 [&>h4]:mb-2 [&_strong]:text-foreground"
                    dangerouslySetInnerHTML={{ __html: post.intro }}
                  />
                )}
                {post.content.map((section) => (
                  <section key={section.id} id={section.id} className={`mb-12 scroll-mt-28 first-of-type:mt-0${section.presentation === "summary" ? " blog-summary rounded-xl p-5 md:p-6" : ""}`}>
                    <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4 mt-4">
                      {section.title}
                    </h2>
                    {section.faqItems ? <BlogFAQ items={section.faqItems} /> : <div
                      className="text-muted-foreground leading-relaxed [&>p]:mb-4 [&>ul]:mb-4 [&>ul]:list-disc [&>ul]:pl-6 [&>ol]:mb-4 [&>ol]:list-decimal [&>ol]:pl-6 [&>li]:mb-2 [&>h4]:text-lg [&>h4]:font-semibold [&>h4]:text-foreground [&>h4]:mt-6 [&>h4]:mb-2 [&_strong]:text-foreground"
                      dangerouslySetInnerHTML={{ __html: section.content }}
                    />}
                  </section>
                ))}
                {post.closingNote && (
                  <p className="text-muted-foreground leading-relaxed">
                    {post.closingNote.before}
                    <Link to={post.closingNote.to} className="text-accent underline underline-offset-4">{post.closingNote.linkText}</Link>
                    {post.closingNote.after}
                  </p>
                )}
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogContent;
